<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh3"><a id="page_xxiii"></a><span class="bold">List of Maps</span></h2>
<p class="entry0"><a href="#/xhtml/13_Chapter1#map1"><span class="epad">1.</span> The Border Marches</a></p>
<p class="entry0"><span href="#/xhtml/16_Chapter4#map2" title="Link target outside of Sample"><span class="epad">2.</span> The Battle of Otterburn</span></p>
<p class="entry0"><span href="#/xhtml/18_Chapter6#map3" title="Link target outside of Sample"><span class="epad">3.</span> The Battle of Homildon Hill</span></p>
<p class="entry0"><span href="#/xhtml/20_Chapter8#map4" title="Link target outside of Sample"><span class="epad">4.</span> The Battle of Shrewsbury</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Maps.vue?5b14a4d4